import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IRegEdUserMap, IRegEdUserMapUpsertRequest } from './types';
import { invalidateRegEdMyUserMap } from './useRegEdMyUserMapQuery';

export const useRegEdUserMapUpsertMutation = ({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (result: IRegEdUserMap) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			regEdUserId,
			impersonationContext,
		}: {
			regEdUserId: string;
			impersonationContext?: Api.IImpersonationContext;
		}) => {
			const request: IRegEdUserMapUpsertRequest = { regEdUserId };
			return userSession.webServiceHelper.callAsync<IRegEdUserMap>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: 'compliance/regEd/userMap/me' }),
				'POST',
				request
			);
		},
		onError,
		onSuccess: result => {
			invalidateRegEdMyUserMap();
			onSuccess?.(result);
		},
	});
};
